import addIcons from './addIcons.jsx';
import addTabType from './addTabType';
import filterRoleGroups from './filterRoleGroups';
import filterTabs from './filterTabs';
import makeGroupByAppName from './makeGroupByAppName';
import makeGroupBySubMenus from './makeGroupBySubMenus';

/**
 * @async
 * @function filterCanTabs
 * @param { Object } data
 * @param { array } data.apps
 * @param { array } data.menus
 * @param { array } data.roleGroups
 * @param { array } data.tabs
 * @param { array } data.userRoleGroups
 * @returns { Promise<Array> } cantabs
 */
async function filterCanTabs(data) {
	const { apps, menus, roleGroups, tabs, userRoleGroups } = data;

	const _roleGroups = await filterRoleGroups(
		userRoleGroups,
		roleGroups,
		apps,
	);
	const _tabs = await filterTabs(_roleGroups, menus, tabs);
	const _apps = await makeGroupByAppName(_tabs);
	const _cantabs = await makeGroupBySubMenus(_apps, tabs);
	const __cantabs = await addTabType(_cantabs);
	const cantabs = addIcons(__cantabs);

	return cantabs;
}

export default filterCanTabs;
